import { render, staticRenderFns } from "./LanguagesMenu.vue?vue&type=template&id=5b6169ef&scoped=true"
import script from "./LanguagesMenu.vue?vue&type=script&lang=js"
export * from "./LanguagesMenu.vue?vue&type=script&lang=js"
import style0 from "./LanguagesMenu.vue?vue&type=style&index=0&id=5b6169ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6169ef",
  null
  
)

export default component.exports